import { useCallback, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import TextField from "@mui/material/TextField";

import Api from "../../../../services/Api";
import useAuth from "../../../login/AuthContext";

export const TagEditModal = ({ state, setData, onSuccess }) => {
  const { name, id } = state || {};
  const show = id >= 0;
  const [value, setValue] = useState(name);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { getAuthToken } = useAuth();
  const onClose = useCallback(() => {
    setData(null);
    setLoading(false);
  }, []);
  const onChange = useCallback((event) => {
    setValue(event.target.value);
  }, []);
  const onEdit = useCallback(async () => {
    setLoading(true);
    const response = await Api.updateTag(id, value, await getAuthToken());

    if (response.status === 200) {
      onSuccess(response.parsedBody);
    } else {
      setError(response.parsedBody?.error?.description || true);
    }

    setLoading(false);
  }, [id, getAuthToken, value]);

  useEffect(() => {
    if (show) {
      setError(false);
      setValue(name);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Tag</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error ? (
          <Alert variant="danger">
            {typeof error === "string" ? "Error - " + error : "An error occurred while editing tag"}
          </Alert>
        ) : null}

        <p>
          Tag to edit: <b>{name}</b>
        </p>

        <TextField variant="outlined" value={value} placeholder="Tag Name" onChange={onChange} />
      </Modal.Body>

      <Modal.Footer>
        {loading ? <Spinner variant="primary" size="sm" animation="border" /> : null}
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onEdit} disabled={!value || value === name || loading}>
          Update Tag
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
